var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tg-icon-logo",class:_vm.site})
}
var staticRenderFns = []

export { render, staticRenderFns }